<script setup>
import {useRoute} from "vue-router";
import {computed, onMounted, ref} from "vue";
import {storeLst} from "@/utils/qiaopaiGas";
import router from "@/router";

const route = useRoute()
const search = ref({})
const data = computed(() => {
  let values = `${route.query.ids}#`
  const data = storeLst[values].data
  const _its = {area: [], city: []}
  data.forEach(item => {
    if (!_its.area.some(its => its.text === item.area)) {
      _its.area.push({text: item.area, value: item.area})
    }
    if (!_its.city.some(its => its.text === item.city)) {
      _its.city.push({text: item.city, value: item.city})
    }
  })
  search.value = _its
  return data
})

const back = () => {
  router.replace({name: "home"})
}

const filterHandler = (value, row, column) => {
  const property = column['property'];
  //重置筛选项目
  // console.log(property)
  return row[property] === value;
}
onMounted(() => {
  document.title = '优惠券适用加油站'
})

const filtersChange = (filters) => {
  const keys = Object.keys(filters)
  let k = keys[0] === 'city' ? 'area' : 'city';
  let d = filters[keys[0]]
  search.value[k] = []
  data.value.forEach(item => {
    if ((Object.keys(d).length < 1 || d.some(c => c === item[keys[0]])) && !search.value[k].some(its => its.text === item[k])) {
      search.value[k].push({text: item[k], value: item[k]})
    }
  })
}
</script>

<template>
  <div class="back" @click="back">
    <el-icon>
      <ArrowLeft/>
    </el-icon>
    <div>{{ route.query.ids }}#优惠券适用加油站</div>
  </div>
  <el-table class="tabs" stripe :data="data" @filter-change="filtersChange">
    <el-table-column prop="name" label="加油站"/>
    <el-table-column prop="city" label="城市" :filters="search.city" :filter-method="filterHandler" column-key="city"/>
    <el-table-column prop="area" label="区域" :filters="search.area" :filter-method="filterHandler" column-key="area"/>
    <el-table-column prop="address" label="地址"/>
  </el-table>
</template>

<style scoped lang="less">
.back {
  height: 45px;
  line-height: 45px;
  display: flex;
  align-items: center;
  //box-sizing: border-box;
  padding: 0 15px;
}

.tabs {
  height: calc(100vh - 45px);
}

</style>
